const editProfileInfoDictEN = {
  choose: "Choose",
  cancel: "Cancel",
  dragImgFile: "Drag image file here",
  zipCode: "Zip Code",
  country: "Country",
  state: "State",
  city: "City",
  publicPlace: "Public Place",
  district: "District",
  number: "Number",
  countryPhoneCode: "Country Phone Code",
  regionalPhoneCode: "Regional Phone Code",
  phoneNumber: "Phone Number",
  changeProfilePic: "Change Profile Picture",
  confirmProfileChanges: "Confirm Profile Changes",
  // toast
  pleaseChoosePfp: "Please choose a profile picture first.",
  fileSizeTooBig: "File size is too big.",
  unexpectedErrorUploadImg: "Unexpected error while uploading image.",
  usernameCantBeEmpty:
    "The user name must contain only lowercase letters and numbers. It cannot be empty or contain spaces.",
  usernameNotAvailable: "Username not available.",
  unexpectedErrorChangingPfp: "Unexpected error while changing profile.",
  sucessfullyEditedProfile: "Successfully edited profile.",
  unexpectedSystemBehaviour: "Unexpected system behaviour.",
  canRetriveOnSaturdays: "Can the shipping service retrieve the order on Saturdays?",
  quantityOfDaysToRetrive:
    "Quantity of days for the shipping service to retrieve your order and take it to its destination",
  settingsPageTitle: "Settings",
  settingsPageProfileInfoTitle: "Profile information",
  settingsPageSubtitle: "Manage your preferences and options.",
  upgradeAccount: "Upgrade account",
  logout: "Logout",
  settingsTabGeneral: "General settings",
  settingsTabProfile: "Profile settings",
  profileSettingsSubtitle: "Update your profile and shipping preferences.",
  settingsTabPrivacy: "Privacy and security",
  settingsMenuSelection: "Selection menu",
  regionalPreferences: "Regional preferences",
  regionalPreferencesSubtitle: "Select the preferences for your region.",
  language: "Language",
  timezone: "Timezone",
  timeFormatOptional: "Time format (Optional)",
  dateFormatOptional: "Date format (Optional)",
  hours: "hours",
  contactInfo: "Contact information",
  contactInfoSubtitle: "Enter your phone number and address.",
  applyChanges: "Apply changes",
  confirm: "Confirm",
  changePassword: "Change password",
  changePasswordSubtitle: "Update your password for better account security.",
  currentPassword: "Current password",
  newPassword: "New password",
  confirmPassword: "Confirm new password",
  passwordMustContainAtLeast: "Must contain at least:",
  passwordRequirementUppercase: "1 uppercase letter",
  passwordRequirementNumber: "1 number",
  passwordRequirementLength: "8 characters",
  passwordStrengthNone: "",
  passwordStrengthWeak: "Weak",
  passwordStrengthMedium: "Medium",
  passwordStrengthStrong: "Strong",
  loading: "Loading...",
  deleteAccount: "Delete account",
  deleteAccountSubtitle: "Manage the account cancellation process.",
  deleteAccountWarning: "This action cannot be undone.",
  deleteAccountInfo: "All your data, including profile and personal information, will be permanently removed.",
  writeCancelToConfirm: "Type CANCEL to confirm",
  confirmYourPassword: "Confirm your password",
  passwordChangedSuccessfully: "Password changed successfully.",
  accountCanceledSuccessfully: "Account canceled successfully.",
  passwordFieldsMismatched: "Passwords do not match.",
  cancelAccountError: "Error canceling account.",
  firstName: "First name",
  surname: "Surname",
  username: "Username",
  uploadImage: "Upload image",
  freight: "Freight",
  select: "Select",
  profileAnalysisTab: "Profile analysis",
  profileAnalysisMenuItem: "Profile analysis",
  profileAnalysisTitle: "Profile and Goals Analysis",
  profileAnalysisSubtitle:
    "Answer these short questions to help us understand your goals.",
  profileAnalysisAddress: "Address",
  profileAnalysisAddressHelp: "Enter your current residence address.",
  profileAnalysisNationality: "Nationality",
  profileAnalysisBirthPlace: "Place of Birth",
  profileAnalysisBirthDate: "Date of Birth",
  profileAnalysisBirthDatePlaceholder: "DD/MM/YYYY",
  profileAnalysisPhone: "Phone",
  profileAnalysisEmail: "E-mail",
  profileAnalysisEmployment: "Employment",
  profileAnalysisMaritalStatus: "Marital Status",
  profileAnalysisEducationLevel: "Education Level",
  profileAnalysisHouseholdMembers: "Household Members",
  profileAnalysisObjectives: "Objectives",
  profileAnalysisNeeds: "Needs",
  profileAnalysisDateLabel: "Date: ",
  profileAnalysisConsultantLabel: "Consultant: ",
  profileAnalysisNoData: "—",
  profileAnalysisConsentLabel: "I consent",
  profileAnalysisConsentText:
    "The information will be used to produce a free assessment for the EXTRACONOMY platform.",
  profileAnalysisSendDiagnosis: "Send diagnosis",
  profileAnalysisUpdateDiagnosis: "Update diagnosis",
  profileAnalysisSubmitSuccess: "Diagnosis sent successfully.",
  profileAnalysisMaritalSingle: "Single",
  profileAnalysisMaritalMarried: "Married",
  profileAnalysisMaritalDivorced: "Divorced",
  profileAnalysisMaritalWidowed: "Widowed",
  profileAnalysisMaritalCivilUnion: "Civil union",
  profileAnalysisMaritalSeparated: "Separated",
};

export default editProfileInfoDictEN;
